import { Suspense } from 'react'
import { Box } from '@mui/material'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import { AppShellLayoutContext } from '@/components/AppShell/AppShellLayoutContext'
import { Outlet } from 'react-router-dom'
import { DocumentPreviewProvider } from '@/features/documentPreview/DocumentPreviewContext.jsx'
import { appShellLayoutSx } from './appShellLayoutSx.js'
import { AppShellSecondaryNavSlot } from './AppShellSecondaryNavSlot.jsx'
import IntegrationsModal from '@/components/IntegrationsModal/IntegrationsModal'
import SettingsModal from '@/components/Settings/SettingsModal/SettingsModal'

export default function AppShellLayoutView({ layout }) {
  const { secondaryNavProps } = layout

  return (
    <AppShellLayoutContext.Provider value={layout}>
      <DocumentPreviewProvider>
        <Box sx={appShellLayoutSx}>
          <AppShellSecondaryNavSlot secondaryNavProps={secondaryNavProps} />
          <Suspense fallback={<RouteSuspenseFallback />}>
            <Outlet />
          </Suspense>
          <SettingsModal />
          <IntegrationsModal />
        </Box>
      </DocumentPreviewProvider>
    </AppShellLayoutContext.Provider>
  )
}
